/**
 * 직거래 상태 enum
 */
export const DIRECT_DEAL_STATUS = {
  THINK: "Type-Think",
  SEARCH: "Type-Search",
  CONFIRM: "Type-Confirm",
};

/**
 * 직거래 상태 라벨
 */
export const DIRECT_DEAL_STATUS_LABEL = {
  [DIRECT_DEAL_STATUS.THINK]: "직거래고민중",
  [DIRECT_DEAL_STATUS.SEARCH]: "직거래매물탐색",
  [DIRECT_DEAL_STATUS.CONFIRM]: "직거래매물확정",
};

/**
 * 직거래 상태 값 → 라벨 변환
 * @param {string} status
 * @returns {string}
 */
export const getDirectDealStatusLabel = status => {
  return DIRECT_DEAL_STATUS_LABEL[status] || status;
};

export default {
  DIRECT_DEAL_STATUS,
  DIRECT_DEAL_STATUS_LABEL,
  getDirectDealStatusLabel,
};
